import React, { useContext, useEffect } from "react";
import logo from "../../images/splash-logo.svg";
import { UserContext } from "../../App";

const Splash = () => {
  const { userContextState } = useContext(UserContext);

  useEffect(() => {
    if (window.location.pathname === "/splash") {
      setTimeout(() => {
        if (userContextState && userContextState?.route) {
          window.location.replace(userContextState?.route);
        } else {
          window.location.replace("/onboarding");
        }
      }, 3000);
    }
  }, []);

  return (
    <section className="splash">
      <div className="logo">
        <img src={logo} alt="splash-logo" />
      </div>
      <p>Create connections & grow businesses</p>
    </section>
  );
};

export default Splash;
